export default {
  optionsBackgroundColor: 'brandOne100',
  optionsHoverBackgroundColor: 'brandOne20',
  optionsBackgroundColorUnselected: 'brandOne10',
  optionsBorderRadius: 'medium',
  optionsHoverUnderline: false,
  optionsBorderColor: 'brandOne100',
  filterIconColor: 'brandOne100',
};
